import React from "react";
import CartDrawer from "./CartDrawer";

const CartPage = () => {
  return <CartDrawer mode="page" open={true} serviceType="delivery" />;
};

export default CartPage;